(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('FilterComposer', FilterComposer);

    function FilterComposer() {
        return {
            constructFilter: constructFilter,
            editFilter: editFilter
        };

        function constructFilter(filterName, operator, value, data) {
            var filter = {
                field: filterName,
                operator: operator,
                value: value
            };

            // Fix ENUM REMOTE
            if (data) {
                filter = Object.assign(filter, { data: data });
            }

            return filter;
        }

        function editFilter(filter, operator, value, data) {
            filter.operator = operator;
            filter.value = value;

            // Fix ENUM REMOTE
            if (data) {
                filter.data = data;
            }
        }
    }
})();